import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/search.svg'
import _imports_1 from '@/assets/icons/plus.svg'


const _hoisted_1 = { class: "flex flex-col h-screen" }
const _hoisted_2 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_3 = { class: "container py-8" }
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_5 = { class: "flex flex-col lg:flex-row items-center justify-between mb-8" }
const _hoisted_6 = { class: "flex flex-row items-center w-full lg:w-1/2" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-4 h-4"
}, null, -1)
const _hoisted_8 = { class: "flex flex-col lg:flex-row items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-4 h-4"
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-4" }, "Add new expense")
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_12 = {
  key: 0,
  class: "font-semibold text-xl mb-4"
}
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 2,
  class: "font-semibold text-xl mb-4"
}
const _hoisted_15 = { class: "flex flex-row items-center justify-center mt-4" }
const _hoisted_16 = {
  key: 2,
  class: "flex flex-col"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl font-semibold mb-4" }, "Extra charges", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CardExtraCharge = _resolveComponent("CardExtraCharge")!
  const _component_ReimbursementCard = _resolveComponent("ReimbursementCard")!
  const _component_v_pagination = _resolveComponent("v-pagination")!
  const _component_ModalExpenses = _resolveComponent("ModalExpenses")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.error)
            ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                      onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTitle($event))),
                      type: "text",
                      placeholder: "Search...",
                      class: "focus:outline-none bg-background ml-4 flex-grow"
                    }, null, 544), [
                      [_vModelText, _ctx.searchQuery]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_Filter, {
                      modelValue: _ctx.typeOfExpense,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.typeOfExpense) = $event)),
                      name: "type",
                      options: _ctx.expensesOptions,
                      class: "mr-8"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_Filter, {
                      modelValue: _ctx.filter,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter) = $event)),
                      name: "category",
                      options: _ctx.filterOptions,
                      class: "mr-8"
                    }, null, 8, ["modelValue", "options"]),
                    _createVNode(_component_Filter, {
                      modelValue: _ctx.status,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.status) = $event)),
                      name: "status",
                      options: _ctx.statusOptions,
                      class: "mr-8"
                    }, null, 8, ["modelValue", "options"]),
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openModal = true)),
                      class: "btn-filled-lg"
                    }, _hoisted_10)
                  ])
                ]),
                (_ctx.loading)
                  ? (_openBlock(), _createBlock(_component_Loader, {
                      key: 0,
                      class: "mt-4"
                    }))
                  : (
                _ctx.typeOfExpense === 'all' || _ctx.typeOfExpense === 'reimbursements'
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (
                  _ctx.typeOfExpense === 'all' || _ctx.typeOfExpense === 'extra_charges'
                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Extra charges"))
                          : _createCommentVNode("", true),
                        (_ctx.typeOfExpense === 'all' && _ctx.currentPage === 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraCharges, (charge, i) => {
                                return (_openBlock(), _createElementBlock("div", { key: i }, [
                                  _createVNode(_component_CardExtraCharge, { extraCharge: charge }, null, 8, ["extraCharge"])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (
                  _ctx.typeOfExpense === 'all' || _ctx.typeOfExpense === 'reimbursements'
                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Reimbursements"))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pending, (reimbursement, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(_component_ReimbursementCard, {
                              reimbursement: reimbursement,
                              updateData: _ctx.refreshData,
                              "onUpdate:updateData": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.refreshData) = $event))
                            }, null, 8, ["reimbursement", "updateData"])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approved, (reimbursement, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(_component_ReimbursementCard, {
                              reimbursement: reimbursement,
                              updateData: _ctx.refreshData,
                              "onUpdate:updateData": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.refreshData) = $event))
                            }, null, 8, ["reimbursement", "updateData"])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paid, (reimbursement, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(_component_ReimbursementCard, {
                              reimbursement: reimbursement,
                              updateData: _ctx.refreshData,
                              "onUpdate:updateData": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.refreshData) = $event))
                            }, null, 8, ["reimbursement", "updateData"])
                          ]))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.denied, (reimbursement, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(_component_ReimbursementCard, {
                              reimbursement: reimbursement,
                              updateData: _ctx.refreshData,
                              "onUpdate:updateData": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.refreshData) = $event))
                            }, null, 8, ["reimbursement", "updateData"])
                          ]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_v_pagination, {
                            modelValue: _ctx.currentPage,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentPage) = $event)),
                            pages: _ctx.pagination.total_pages,
                            "range-size": 1,
                            "active-color": "#4D00C5"
                          }, null, 8, ["modelValue", "pages"])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.extraCharges, (charge, i) => {
                          return (_openBlock(), _createElementBlock("div", { key: i }, [
                            _createVNode(_component_CardExtraCharge, { extraCharge: charge }, null, 8, ["extraCharge"])
                          ]))
                        }), 128))
                      ]))
              ]))
        ])
      ])
    ]),
    _createVNode(_component_ModalExpenses, {
      openModal: _ctx.openModal,
      "onUpdate:openModal": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.openModal) = $event)),
      refreshData: _ctx.refreshData,
      "onUpdate:refreshData": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.refreshData) = $event))
    }, null, 8, ["openModal", "refreshData"])
  ]))
}